import { IDomain, HtmlType } from "../common/dto/idomain";
import { formatNumber } from "../common/field/renderer";
import { InputComponentType } from "../common/component/input/input";

class WeightKgs implements IDomain<number> {

    public htmlType: HtmlType = "text";
    public inputComponent: InputComponentType = "textField";

    public format(valueToFormat?: number) {
        if (valueToFormat !== undefined) {
            return (valueToFormat / 1000).toString() + " kg";
        }
        return "";
    }

    public unformat(valueToUnformat: string) {
        if (valueToUnformat) {
            const escaped = formatNumber(valueToUnformat);
            if (escaped) {
                return (+escaped) * 1000;
            }
        }
        return undefined;
    }

    public validators = [];
}

export const weightKgs = new WeightKgs();
